import * as Yup from 'yup';

const newRegistro = {
  patrimonio: null,
  tipo: 'POR_DATA',
  status: 'A_NOTIFICAR',
  titulo: '',
  descricao: null,
  isRecorrente: false,
  alertaManutencaoAnterior: null,
  ultimoAlertaData: null,
  intervaloRecorrenciaDias: null,
  dataProximoAlerta: null,
  ultimoAlertaHorimetro: null,
  intervaloRecorrenciaHoras: null,
  horimetroProximoAlerta: null,
  ultimoAlertaOdometro: null,
  intervaloRecorrenciaKM: null,
  odometroProximoAlerta: null,
};

const validation = Yup.object().shape({
  patrimonio: Yup.object()
    .typeError('Este campo é obrigatório')
    .shape({
      id: Yup.number()
        .typeError('Este campo é obrigatório')
        .required('Este campo é obrigatório'),
    })
    .nullable(),
  
  tipo: Yup.string()
    .typeError('Este campo é obrigatório')
    .required('Este campo é obrigatório'),

  titulo: Yup.string()
    .min(2, 'O campo deve ter no mínimo 2 caracteres')
    .max(120, 'Campo deve ter menos do que 120 caracteres')
    .required('Este campo é obrigatório'),

  descricao: Yup.string()
    .nullable()
    .max(2000, 'Campo deve ter menos do que 2000 caracteres'),

  // Regras condicionais para `POR_DATA`
  dataProximoAlerta: Yup.date()
    .nullable()
    .typeError('O campo Data Próximo Alerta deve ser uma data válida')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_DATA' && !isRecorrente,
      then: Yup.date()
        .required('O campo Data Próximo Alerta é obrigatório')
        .nullable(),
    }),

  ultimoAlertaData: Yup.date()
    .nullable()
    .typeError('O campo Último Alerta Data deve ser uma data válida')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_DATA' && isRecorrente,
      then: Yup.date()
        .required('O campo Último Alerta Data é obrigatório')
        .nullable(),
    }),

  intervaloRecorrenciaDias: Yup.number()
    .nullable()
    .typeError('O campo Intervalo de Recorrência (Dias) deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_DATA' && isRecorrente,
      then: Yup.number()
        .required('O campo Intervalo de Recorrência (Dias) é obrigatório')
        .nullable(),
    }),

  // Regras condicionais para `POR_HORIMETRO`
  horimetroProximoAlerta: Yup.number()
    .nullable()
    .typeError('O campo Horímetro Próximo Alerta deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_HORIMETRO' && !isRecorrente,
      then: Yup.number()
        .required('O campo Horímetro Próximo Alerta é obrigatório')
        .nullable(),
    }),

  ultimoAlertaHorimetro: Yup.number()
    .nullable()
    .typeError('O campo Último Alerta Horímetro deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_HORIMETRO' && isRecorrente,
      then: Yup.number()
        .required('O campo Último Alerta Horímetro é obrigatório')
        .nullable(),
    }),

  intervaloRecorrenciaHoras: Yup.number()
    .nullable()
    .typeError('O campo Intervalo de Recorrência (Horas) deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_HORIMETRO' && isRecorrente,
      then: Yup.number()
        .required('O campo Intervalo de Recorrência (Horas) é obrigatório')
        .nullable(),
    }),

  // Regras condicionais para `POR_ODOMETRO`
  odometroProximoAlerta: Yup.number()
    .nullable()
    .typeError('O campo Odômetro Próximo Alerta deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_ODOMETRO' && !isRecorrente,
      then: Yup.number()
        .required('O campo Odômetro Próximo Alerta é obrigatório')
        .nullable(),
    }),

  ultimoAlertaOdometro: Yup.number()
    .nullable()
    .typeError('O campo Último Alerta Odômetro deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_ODOMETRO' && isRecorrente,
      then: Yup.number()
        .required('O campo Último Alerta Odômetro é obrigatório')
        .nullable(),
    }),

  intervaloRecorrenciaKM: Yup.number()
    .nullable()
    .typeError('O campo Intervalo de Recorrência (KM) deve ser um número')
    .when(['tipo', 'isRecorrente'], {
      is: (tipo, isRecorrente) => tipo === 'POR_ODOMETRO' && isRecorrente,
      then: Yup.number()
        .required('O campo Intervalo de Recorrência (KM) é obrigatório')
        .nullable(),
    }),
});

export const patrimonioAlertaManutencaoCadastro = {
  newRegistro,
  validation,
};
